export default "__VITE_ASSET__b5685d3d__"